module.exports = __webpack_public_path__ + "static/img/cp-top.fe17e1ab.png";